module.exports = __webpack_public_path__ + "static/media/GothamSSm-Bold.e58ae00f.otf";